import React, { useEffect, useState } from 'react';
import {useSearchParams, useNavigate} from 'react-router';
import useAuth from '../Hooks/useAuth';
import { Stack, Typography, CircularProgress } from '@mui/material';
import useDashboardToken from '../Hooks/useDashboardToken';
import usePhysicianDashboardUser from '../Hooks/usePhysicianDashboardUser';
import { physicianDashboardSlice } from '../../api/physicianDashboardSlice';
import useAnalytics from '../Hooks/useAnalytics';
import InvalidToken from '../PhysicianDashboard/InvalidToken';

function PhysicianDashboardAuthRedirect() {
    const [searchParams, ] = useSearchParams();
    const analytics = useAnalytics();
    const { physicianDashboardToken, setPhysicianDashboardToken } = useDashboardToken();
    const { dashboardUser, setDashboardUser } = usePhysicianDashboardUser();
    const { setPhysicianDashboardAuthed } = useAuth();
    const [getCurrentUser] = physicianDashboardSlice.endpoints.getCurrentDashboardUser.useLazyQuery();
    const navigate = useNavigate();
    const [shouldShowInvalidToken, setShouldShowInvalidToken] = useState(false);

    useEffect(() => {
        try {
            console.warn('[AuthRedirect] useEffect fired:', {
                hasTokenParam: !!searchParams.get('token'),
                hasStoredToken: !!localStorage.getItem('dashboardToken'),
                componentMounted: true
            });
        } catch (e) {
            console.error('[AuthRedirect] Error logging token info:', e);
        }

        if (searchParams.get('token')) {
            setPhysicianDashboardToken(searchParams.get('token'));
            getCurrentUser().unwrap().then((user) => {
                setDashboardUser(user);
                setPhysicianDashboardAuthed(true);
                analytics.identify('owner-' + user.id, {
                    'name': user.name,
                    'specialty': user.specialty,
                });
                navigate('/physician/dashboard/landing');
            }).catch((error) => {
                console.error('[AuthRedirect] getCurrentUser FAILED, clearing token:', error);
                setPhysicianDashboardToken(null);
                setDashboardUser(null);
                setShouldShowInvalidToken(true);
            });
        } else if (!physicianDashboardToken || !dashboardUser) {
            setShouldShowInvalidToken(true);
        } else {
            navigate('/physician/dashboard/landing');
        }
    }, [searchParams]);

    if (shouldShowInvalidToken) {
        return <InvalidToken />;
    }

    return(
        <Stack width="100%" height="100%">
            <Stack width="100%" height="100%" justifyContent="center" alignItems="center" spacing={2}>
                <Typography variant="h4">Validating your token. Hang tight...</Typography>
                <CircularProgress />
            </Stack>
        </Stack>
    );
}

export default PhysicianDashboardAuthRedirect;
